import _ from 'lodash';
import { Order, OrderPatient, OrderStatus } from 'models/order';
import { CONSTANTS } from 'config/constants';
import { OrderInputType } from 'models/order-input/shared';

const { ORDER_STATUSES } = CONSTANTS;

export const orderStatusEnumToValue = (status: OrderStatus): string => {
    const match = ORDER_STATUSES.filter((e) => e.name === status.toString());
    if (match.length > 0) {
        return match[0].value;
    }
    throw new Error('No matching order status for: ' + status);
};

export const extractOrderInputType = (order: Order) => {
    if (order.isDraft && order.isCopyOrder) {
        return OrderInputType.COPY;
    }
    if (order.isDraft && order.isWarrantyOrder) {
        return OrderInputType.WARRANTY;
    }
    return OrderInputType.MODIFY;
};

/**
 * DD-3473: the stored `isSupplierOrder` flag is gone from the Order GraphQL type.
 * A supplier order is an order placed by a lab (the customer organization is a lab
 * ordering from another lab). Callers must select `customer { type }` in their query.
 */
export const isSupplierOrder = (order: Pick<Order, 'customer'>): boolean => {
    return order.customer?.type === 'lab';
};

/**
 * The patient's display name, or '' when the server withheld the patient.
 *
 * DD-3620: a restricted external user receives no patient, and Apollo stores that
 * as an **empty object**, not null — so `order.patient ? ... : ''` is true and
 * renders "undefined undefined". Test the name fields, never the object.
 */
export const patientDisplayName = (patient?: OrderPatient | null): string =>
    [patient?.firstName, patient?.lastName].filter(Boolean).join(' ');
